<template>
  <span class="caption pa-0 ma-0" style="font-size: 10px !important;">{{
    captionText
  }}</span>
</template>

<script>
export default {
  mixins: [],
  props: {
    subcategory: {
      type: Object,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    insightSubjectiveMetric() {
      return (
        this.subcategory.subcatInsightMetric == 0 ||
        this.subcategory.subcatInsightMetric == 1
      );
    },
    insightMetricType() {
      switch (this.subcategory.subcatInsightMetric) {
        case 0:
          return "sentiment";
        case 1:
          return "emotion";
        case 2:
          return "silence";
        default:
          return "overtalk";
      }
    },
    insightChannelText() {
      switch (this.subcategory.subcatInsightChannel) {
        case 0:
          return " Agent ";
        case 1:
          return " Customer ";
        default:
          return " Overall ";
      }
    },
    valueRangeText() {
      switch (this.subcategory.insightValueRange) {
        case 0:
          return "Positive ";
        case 1:
          return "Neutral ";
        default:
          return "Negative ";
      }
    },
    subcatWeight() {
      return this.subcategory.catScoringRule == 0
        ? " / Weight: " + this.subcategory.subcatWeight
        : "";
    },
    locationText() {
      if (this.insightSubjectiveMetric) {
        return this.subcategory.subcatLocationBeginning
          ? " Beginning "
          : " End ";
      }
      return "";
    },
    captionText() {
      let metricType = this.insightMetricType;
      let scString = metricType.charAt(0).toUpperCase() + metricType.slice(1);
      let valueText = "";
      let valueRangeText = "";

      if (!this.insightSubjectiveMetric) {
        valueText = " <= " + this.subcategory.subcatInsightValue + "%";
      } else {
        valueRangeText = this.valueRangeText;
      }

      return (
        valueRangeText +
        this.locationText +
        this.insightChannelText +
        scString +
        valueText +
        this.subcatWeight
      );
    }
  },
  methods: {
    formatPercent(val) {
      return String(Math.round(val * 100)) + "%";
    }
  }
};
</script>
<style scoped></style>
